import DeleteIcon from '@mui/icons-material/Delete';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';

const SavDraftDeleteModal = ({
  isOpen,
  handleClose,
  onConfirm,
  confirmLoading,
  draftReference,
}) => {
  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          borderBottom: 1,
          marginBottom: 2,
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          fontSize: 20,
          color: 'error.main',
        }}
      >
        <DeleteIcon />
        Suppression du brouillon - {draftReference}
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          Êtes-vous sûr de vouloir supprimer le brouillon de commande SAV ?
          Cette action est irréversible.
        </DialogContentText>
      </DialogContent>

      <DialogActions
        sx={{ p: 2, display: 'flex', justifyContent: 'space-between' }}
      >
        <Button variant="outlined" color="info" onClick={handleClose}>
          Annuler
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          endIcon={
            confirmLoading ? <CircularProgress size={16} /> : <DeleteIcon />
          }
          disabled={confirmLoading}
        >
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SavDraftDeleteModal;
